/**
 * スクロール位置に基づくbodyクラスの切り替え
 */
document.addEventListener("DOMContentLoaded", () => {
  const checkFirstView = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.toggle("not-first-view", scrollTop !== 0);
  };

  ["load", "resize", "scroll", "orientationchange"].forEach((event) => {
    window.addEventListener(event, checkFirstView);
  });
});

/**
 * パララックス背景画像のスクロール連動
 */
document.addEventListener("DOMContentLoaded", () => {
  const bgElements = document.querySelectorAll(".parallax__image");
  if (bgElements.length === 0) return;

  const updateBackgroundPosition = () => {
    const windowHeight = window.innerHeight;

    bgElements.forEach((bgElement) => {
      const rect = bgElement.getBoundingClientRect();
      // 要素がビューポートに入る割合を計算 (0 ~ 1 の範囲)
      const progress = 1 - Math.max(0, Math.min(1, rect.bottom / (rect.height + windowHeight)));
      // 0% ~ 100% に変換
      bgElement.style.backgroundPositionX = `${progress * 100}%`;
    });
  };

  ["scroll", "resize"].forEach((event) => {
    window.addEventListener(event, updateBackgroundPosition);
  });

  updateBackgroundPosition();
});

/**
 * スクロールによる要素の表示状態監視
 */
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".in-view");
  if (elements.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-in-view", entry.isIntersecting);
      });
    },
    { threshold: 0.1 }
  );

  elements.forEach((el) => observer.observe(el));
});

/**
 * ファーストビュー判定用のしきい値を取得
 */
function getFirstViewThreshold() {
  const hero = document.querySelector(".hero__inner");
  const pageHeader = document.querySelector(".page-header");

  if (hero) return hero.offsetHeight;
  if (pageHeader) return pageHeader.offsetHeight;
  return window.innerHeight;
}

/**
 * ファーストビューの判定とクラス切り替え
 */
document.addEventListener("DOMContentLoaded", () => {
  let threshold = getFirstViewThreshold();

  const toggleFirstViewClass = () => {
    document.body.classList.toggle("out-of-first-view", window.scrollY > threshold);
  };

  window.addEventListener("load", toggleFirstViewClass);
  window.addEventListener("scroll", toggleFirstViewClass);
  window.addEventListener("resize", () => {
    threshold = getFirstViewThreshold();
    toggleFirstViewClass();
  });
  window.addEventListener("orientationchange", () => {
    threshold = getFirstViewThreshold();
    toggleFirstViewClass();
  });
});

/**
 * ページ読み込み時の初期化
 */
$(window).on("load", function () {
  $(".cart__quantity-input").trigger("change");
  removeEmptyCartItems();
});

/**
 * ヘッダーのカートバッジを更新
 */
function updateCartBadge() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    cache: false,
    dataType: "json",
  }).then(function (cart) {
    const count = cart.items.reduce((acc, item) => acc + (item.quantity || 0), 0);
    const badge = $(".header__cart-badge");
    badge.text(count);
    badge.toggle(count > 0);
  });
}

/**
 * カート内アイテムの料金を再計算
 */
function recalculateCart() {
  let cartTotal = 0;

  $("[data-product-id]").each(function () {
    const $product = $(this);
    const price = parseInt($product.data("product-price")) || 0;
    const quantitySelector = $product.data("quantity-element");
    const quantity = parseInt($product.find(quantitySelector).val()) || 0;
    const amount = price * quantity;

    const amountSelector = $product.data("amount-element");
    $product.find(amountSelector).html(amount.toLocaleString() + '円<span class="cart__item-price-tax">(税込)</span>');
    cartTotal += amount;
  });

  $(".cart__total-price").html(
    cartTotal.toLocaleString() +
    '<span class="cart__total-price-unit">円</span><span class="cart__total-price-tax">(税込)</span>'
  );
}

/**
 * 在庫0の商品をカートから削除
 */
function removeEmptyCartItems() {
  $("[data-product-id]").each(function () {
    const $product = $(this);
    const productId = $product.data("product-id");
    const quantitySelector = $product.data("quantity-element");
    const quantity = parseInt($product.find(quantitySelector).val()) || 0;

    if (quantity <= 0) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { id: productId, quantity: 0 },
        dataType: "json",
        success: function () {
          $product.fadeOut(250, function () {
            $product.remove();
            recalculateCart();
            updateCartBadge();
          });
        },
      });
    }
  });
}

/**
 * 数量ボタンの状態を更新
 */
function updateQuantityButtons($input, isLoading = false) {
  const value = parseInt($input.val()) || 1;
  const min = parseInt($input.data("min")) || 1;
  const max = parseInt($input.data("max")) || 10;
  const $container = $input.parent();

  const $minusBtn = $container.find("[class*='--minus']");
  const $plusBtn = $container.find("[class*='--plus']");

  if (isLoading) {
    // 処理中は両方のボタンを無効化
    $minusBtn.addClass("disabled");
    $plusBtn.addClass("disabled");
  } else {
    // 処理完了後は値に応じて状態を更新
    $minusBtn.toggleClass("disabled", value <= min);
    $plusBtn.toggleClass("disabled", value >= max);
  }
}

/**
 * 数量ボタンのクリックイベント
 */
$(document).on("click", ".cart__quantity-btn, .product-form__quantity-btn", function () {
  const $btn = $(this);

  // disabledの場合は何もしない
  if ($btn.hasClass("disabled")) return;

  const $input = $btn.siblings(".cart__quantity-input, .product-form__quantity-input");
  let value = parseInt($input.val()) || 1;
  const prevValue = value;
  const min = parseInt($input.data("min")) || 1;
  const max = parseInt($input.data("max")) || 10;

  if ($btn.hasClass("cart__quantity-btn--minus") || $btn.hasClass("product-form__quantity-btn--minus")) {
    if (value > min) value -= 1;
  }
  if ($btn.hasClass("cart__quantity-btn--plus") || $btn.hasClass("product-form__quantity-btn--plus")) {
    if (value < max) value += 1;
  }

  if (value !== prevValue) {
    $input.attr("data-before-value", prevValue);
    $input.val(value);
    $input.trigger("change");
    recalculateCart();
  }
});

/**
 * 数量入力のchangeイベント
 */
$(document).on("change", ".cart__quantity-input, .product-form__quantity-input", function () {
  const $input = $(this);
  if (!$input.val()) return;

  let value = parseInt($input.val());
  const min = parseInt($input.data("min")) || 1;
  const max = parseInt($input.data("max")) || 10;

  // 範囲内に収める
  value = Math.max(min, Math.min(max, value));
  $input.val(value);

  const $parent = $input.parents("[data-product-id]");
  const productId = $parent.length > 0
    ? $parent.attr("data-product-id")
    : $("input[name=id]").val();

  // 処理開始時にボタンを無効化
  updateQuantityButtons($input, true);

  // カートページの場合のみAjax送信
  if ($parent.length > 0) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id: productId, quantity: value },
      dataType: "json",
      success: function () {
        updateCartBadge();
      },
      error: function (error) {
        console.log(error);
        value = parseInt($input.attr("data-before-value")) || 1;
        $input.val(value);
        recalculateCart();
        alert("ご指定の商品は在庫が不足しています。");
      },
      complete: function () {
        // 処理完了後にボタン状態を更新
        updateQuantityButtons($input, false);
      },
    });
  } else {
    // 商品ページの場合は短い遅延後に状態を更新（連打防止）
    setTimeout(function () {
      updateQuantityButtons($input, false);
    }, 200);
  }
});

/**
 * 初期状態で数量ボタンの状態を設定
 */
$(document).ready(function () {
  $(".cart__quantity-input, .product-form__quantity-input").each(function () {
    updateQuantityButtons($(this));
  });
});

/**
 * 商品スライダーの初期化
 */
$(window).on("load resize orientationchange", function () {
  $(".product-gallery__main").not(".slick-initialized").slick({
    autoplay: false,
    infinite: true,
    speed: 500,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: function (slider, index) {
      return $(".product-gallery__nav-item").eq(index).clone();
    },
    dots: $(".product-gallery__nav-item").length >= 1,
  });
  $(".product-gallery__nav").remove();
});

/**
 * 商品バリアント選択の処理
 */
$(document).ready(function () {
  const $variantRadios = $("[data-variants]");
  if ($variantRadios.length === 0) return;

  const variants = JSON.parse($variantRadios.attr("data-variants"));

  $('input[name="option1"], input[name="option2"], input[name="option3"]').on("change", function () {
    const option1 = $('input[name="option1"]:checked').val();
    const option2 = $('input[name="option2"]:checked').val();
    const option3 = $('input[name="option3"]:checked').val();

    const variant = variants.find(function (item) {
      if (option3) {
        return item.option1 === option1 && item.option2 === option2 && item.option3 === option3;
      }
      if (option2) {
        return item.option1 === option1 && item.option2 === option2;
      }
      return item.option1 === option1;
    });

    if (variant) {
      const priceYen = variant.price / 100;
      $(".product-detail__price").html(
        priceYen.toLocaleString() +
        '円<span class="product-detail__price-tax">(税込)</span>'
      );
      $('input[name="id"]').val(variant.id);
    }
  });
});
